import { FOOTER_MJML } from "../common/footer";
import { PRODUCT_HEADER } from "../common/header";

export const productAnnouncement = `
<mjml>
  <mj-head>
    <mj-title>Exciting Announcement: {{announcement_title}}</mj-title>
    <mj-preview>We have something special to share with you about {{product_name}}</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
    </mj-attributes>
    <mj-style>
      .highlight-box {
        background-color: #f0f7ff;
        border-radius: 8px;
        border-left: 4px solid #1890ff;
      }
      .feature-card {
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0,0,0,0.05);
      }
      .testimonial {
        font-style: italic;
        color: #555555;
      }
      .accent-text {
        color: #1890ff;
        font-weight: bold;
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#f5f5f5">
    ${PRODUCT_HEADER("Important Announcement", "Something exciting is here")}
    
    <!-- Main announcement section -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="24px" color="#333333" font-weight="bold" align="center">
          {{announcement_title}}
        </mj-text>
        <mj-divider border-color="#1890ff" border-width="2px" width="100px" padding-top="10px" padding-bottom="20px" />
        <mj-image src="https://via.placeholder.com/600x300?text=Announcement" alt="Announcement" border-radius="8px" />
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 30px 30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="18px" color="#333333" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">
          We're thrilled to announce {{announcement_short_description}}. This represents a significant milestone for us and brings several exciting changes that we can't wait to share with you.
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Highlight box section -->
    <mj-section background-color="#ffffff" padding="0 30px 30px" border-radius="8px">
      <mj-column css-class="highlight-box" padding="20px">
        <mj-text font-size="18px" color="#333333" font-weight="bold">
          {{highlight_title}}
        </mj-text>
        <mj-text font-size="16px" color="#555555">
          {{highlight_description}}
        </mj-text>
        <mj-button background-color="#1890ff" color="#ffffff" href="{{highlight_cta_url}}" border-radius="4px" font-weight="bold" width="200px">
          {{highlight_cta_text}}
        </mj-button>
      </mj-column>
    </mj-section>
    
    <!-- What this means for you section -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="20px" color="#333333" font-weight="bold">What This Means For You</mj-text>
        <mj-divider border-color="#1890ff" border-width="2px" width="80px" padding-bottom="20px" />
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 15px 30px" border-radius="8px">
      <mj-column width="48%" padding="15px" css-class="feature-card">
        <mj-image src="https://via.placeholder.com/80?text=Icon+1" alt="Feature 1" width="80px" />
        <mj-text font-size="18px" font-weight="bold" align="center" padding-top="10px">
          {{benefit_1_title}}
        </mj-text>
        <mj-text font-size="16px" color="#555555" align="center">
          {{benefit_1_description}}
        </mj-text>
      </mj-column>
      <mj-column width="48%" padding="15px" css-class="feature-card">
        <mj-image src="https://via.placeholder.com/80?text=Icon+2" alt="Feature 2" width="80px" />
        <mj-text font-size="18px" font-weight="bold" align="center" padding-top="10px">
          {{benefit_2_title}}
        </mj-text>
        <mj-text font-size="16px" color="#555555" align="center">
          {{benefit_2_description}}
        </mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 15px 30px" border-radius="8px">
      <mj-column width="48%" padding="15px" css-class="feature-card">
        <mj-image src="https://via.placeholder.com/80?text=Icon+3" alt="Feature 3" width="80px" />
        <mj-text font-size="18px" font-weight="bold" align="center" padding-top="10px">
          {{benefit_3_title}}
        </mj-text>
        <mj-text font-size="16px" color="#555555" align="center">
          {{benefit_3_description}}
        </mj-text>
      </mj-column>
      <mj-column width="48%" padding="15px" css-class="feature-card">
        <mj-image src="https://via.placeholder.com/80?text=Icon+4" alt="Feature 4" width="80px" />
        <mj-text font-size="18px" font-weight="bold" align="center" padding-top="10px">
          {{benefit_4_title}}
        </mj-text>
        <mj-text font-size="16px" color="#555555" align="center">
          {{benefit_4_description}}
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Testimonial section -->
    <mj-section background-color="#f0f7ff" padding="30px" border-radius="8px">
      <mj-column width="30%">
        <mj-image src="https://via.placeholder.com/150?text=Customer" alt="Customer" width="150px" border-radius="75px" />
      </mj-column>
      <mj-column width="70%">
        <mj-text font-size="16px" css-class="testimonial">
          "{{testimonial_quote}}"
        </mj-text>
        <mj-text font-size="14px" font-weight="bold" padding-top="10px">
          - {{testimonial_name}}, {{testimonial_title}}
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Call to action section -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="20px" font-weight="bold" align="center">Ready to experience the changes?</mj-text>
        <mj-text font-size="16px" color="#555555" align="center">
          {{cta_description}}
        </mj-text>
        <mj-button background-color="#1890ff" color="#ffffff" font-family="Arial, sans-serif" href="{{cta_url}}" width="250px" border-radius="4px" font-weight="bold" font-size="16px">
          {{cta_button_text}}
        </mj-button>
        <mj-text font-size="14px" color="#777777" align="center" padding-top="10px">
          Questions? <a href="https://www.copilotly.com/contact" style="color: #1890ff; text-decoration: none;">Contact our team</a>
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Timeline/Dates section -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="18px" color="#333333" font-weight="bold">Important Dates</mj-text>
        <mj-divider border-color="#e0e0e0" border-width="1px" padding-bottom="10px" />
        <mj-text font-size="16px">
          <strong class="accent-text">{{date_1}}</strong>: {{date_1_description}}
        </mj-text>
        <mj-text font-size="16px">
          <strong class="accent-text">{{date_2}}</strong>: {{date_2_description}}
        </mj-text>
        <mj-text font-size="16px">
          <strong class="accent-text">{{date_3}}</strong>: {{date_3_description}}
        </mj-text>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "productAnnouncement",
  name: "Product Announcement",
  category: "product",
  description:
    "A visually compelling email template for announcing important product changes, new features, or company updates with clear benefits and timelines.",
  features: [
    "Eye-catching announcement header",
    "Benefit-focused content blocks",
    "Customer testimonial section",
    "Important dates timeline",
    "Strong call-to-action",
  ],
  subject: "Exciting Announcement: {{announcement_title}}",
  subTitle: "We have something special to share with you",
  mjmlTemplate: productAnnouncement,
};
